import { ActionTypes } from '../constants/index';

export const getChannelInfo = (payload: any) => ({
  type: ActionTypes.CHL_INFO_REQUEST,
  payload,
});
